import { msg } from 'gt-react';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { WarningDiamondIcon } from '@phosphor-icons/react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
// fallow-ignore-next-line circular-dependency
import { Route as pathlessAuthenticatedRoute } from '../../route';
import { requireAnyPermission, requireModules } from '../../route';

const ExceptionRulesPage = lazyRouteComponent(
  () => import('./ExceptionRulesPage'),
  'ExceptionRulesPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/accounts-payable/exception-rules',
  staticData: {
    app: {
      nav: {
        label: msg('Exception Rules', {
          context: 'sidebar nav label, Accounts Payable section',
        }),
        icon: <WarningDiamondIcon className="h-4 w-4" weight="fill" />,
        group: 'Accounts Payable',
        order: 6,
        groupOrder: 40,
      },
      access: {
        modulesAnyOf: [ProductModule.AP_INVOICING],
        permissionsAnyOf: [
          { action: Action.Read, subject: Subject.APExceptionRuleSet },
        ],
      },
    },
  },
  component: ExceptionRulesPage,
  loader: () => ({
    crumb: msg('Exception Rules', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.AP_INVOICING],
    });
    await requireAnyPermission({
      context,
      permissions: [
        { action: Action.Read, subject: Subject.APExceptionRuleSet },
      ],
    });
  },
});
